var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Thumbs up, Like",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11728",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11729",
    d: "M6.944 19H5.056A1.056 1.056 0 014 17.944v-7.388A1.056 1.056 0 015.056 9.5h1.888A1.056 1.056 0 018 10.556v7.388A1.056 1.056 0 016.944 19z",
    fill: "none",
    stroke: "#1ea019",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11730",
    d: "M8 10.572l3.649-4.751a1.734 1.734 0 012.714-.046h0a1.792 1.792 0 01.409 1.141v3.271h3.1a1.8 1.8 0 011.5.8l.329.491a1.8 1.8 0 01.234 1.5L18.568 17.7a1.8 1.8 0 01-1.729 1.3H10.55a1.8 1.8 0 01-1.318-.574L8 17.1",
    fill: "none",
    stroke: "#1ea019",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
export default SvgStep8;


//////////////////
// WEBPACK FOOTER
// ./src/components/Quoters/Americo/icons/step_8.svg
// module id = 7603
// module chunks = 13